import { ROUTES } from '../router';

export default function isInQuote(path: string): boolean {
  const startOfPath = path.split('?')[0];

  return !!ROUTES.some((route) => startOfPath === `/${route.path}`);
}
